module.exports = __webpack_public_path__ + "img/intensives-2.b6127c2e.png";